export default __webpack_public_path__ + "static/media/014-apple pie.641b46d7.svg";